module.exports = __webpack_public_path__ + "img/liyiran.a684bff9.jpg";